import React from 'react';
import { Switch } from 'react-router-dom';

import RouteItem from 'components/RouteItem';

import { blogRoutes } from 'pages/blog/routes';

const Blog = () => (
  <Switch>
    {Object.values(blogRoutes).reverse().map((route) => (
      <RouteItem
        key={route.path}
        {...route}
      />
    ))}
  </Switch>
);

export default Blog;
